(function () {
  'use strict';
  var back = document.querySelector('[data-manual-return]');
  var returnPath = new URLSearchParams(location.search).get('manual_return');
  if (back && returnPath) {
    try {
      var target = new URL(returnPath, location.origin);
      if (target.origin === location.origin && target.pathname === '/pages/product-manual-and-update') back.href = target.pathname + target.search;
    } catch (_) { /* Keep the default manual-center link. */ }
  }
  // Word's automatic image-description boilerplate is not customer-facing manual content.
  document.querySelectorAll('#docx-manual img').forEach(function (image) {
    ['alt', 'title'].forEach(function (attribute) {
      var label = image.getAttribute(attribute) || '';
      if (label.includes('AI 生成的内容可能不正确')) {
        if (attribute === 'alt') image.setAttribute('alt', 'Manual illustration');
        else image.removeAttribute(attribute);
      }
    });
  });
  var input = document.getElementById('manual-full-search');
  var body = document.querySelector('#docx-manual .manual-body');
  var results = document.getElementById('manual-full-results');
  if (!input || !body || !results) return;
  var blocks = Array.from(body.querySelectorAll('p,li,h1,h2,h3,h4,h5,h6,td,th')).filter(function (node) {
    return !node.querySelector('p,li,td,th') && node.textContent.trim();
  });
  input.addEventListener('input', function () {
    results.replaceChildren();
    var query = input.value.trim().toLocaleLowerCase();
    if (!query) return;
    blocks.filter(function (node) { return node.textContent.toLocaleLowerCase().includes(query); }).slice(0, 60).forEach(function (node) {
      var button = document.createElement('button');
      button.type = 'button'; button.textContent = node.textContent.trim().slice(0, 240);
      button.addEventListener('click', function () { node.scrollIntoView({block: 'center', behavior: 'smooth'}); });
      results.appendChild(button);
    });
  });
}());
